module.exports = __webpack_public_path__ + "public/img/userId.a128a467.png";